export default "__VITE_ASSET__C8sSaU5b__"